import ApiService from './ApiService';
import authService from './AuthService';

class ProductsCompareService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._listUrl = '/products/compares';
        this._listUrlNonAuth = '/products/compares/non-auth';
        this._listIdsUrl = '/products/compares/ids';
        this._createProductsCompare = '/products/compares/create';
        this._deleteProductsCompare = '/products/compares/delete';
    }

    getBaseHeaders() {
        const authHeader = this._authService.getAuthHeader();

        return { ...authHeader };
    }

    getList(params = {}) {
        const url = this._authService.getAuthToken() ? this._listUrl : this._listUrlNonAuth;

        return this.postResource(url, params, this.getBaseHeaders());
    }

    addToCompare(params) {
        return this.postResource(this._createProductsCompare, params, this.getBaseHeaders());
    }

    removeFromCompare(params) {
        return this.postResource(this._deleteProductsCompare, params, this.getBaseHeaders());
    }

    getUserProductsIDs() {
        return this.postResource(this._listIdsUrl, {}, this.getBaseHeaders());
    }
}

const productsCompareService = new ProductsCompareService(authService);

export default productsCompareService;
